import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

import { createMissingPersonalListInitError } from './errors';
import { setPersonalLineupQueryData } from './mutations';
import { deletePersonalLineup as requestDeletePersonalLineup } from './queryFunctions';
import { usePersonalLineup } from './usePersonalLineup';

export function useResetPersonalLineup() {
  const { allLineups, error } = usePersonalLineup();

  const handleSuccess = useCallback(() => {
    setPersonalLineupQueryData({
      allLineups: [],
      personalLineup: [],
    });
  }, []);

  const mutationFn = useCallback(async () => {
    if (error) {
      throw error;
    }

    if (!allLineups) {
      throw createMissingPersonalListInitError();
    }

    return Promise.all(allLineups.map(requestDeletePersonalLineup));
  }, [error, allLineups]);

  const { mutateAsync, isPending } = useMutation({
    mutationFn,
    onSuccess: handleSuccess,
  });

  const resetPersonalLineup = useCallback(async () => {
    await mutateAsync();
  }, [mutateAsync]);

  return {
    resetPersonalLineup,
    isResetting: isPending,
  };
}
